// FieldShowFilterField.jsx

import React from 'react';

// Components
import Checkbox from 'components/checkbox/Checkbox';
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';

/**
 * FieldShowFilterField
 *
 * Toggle for showing a filter field in single-select Relation pickers.
 *
 * @returns {ReactNode} The rendered control.
 */
const FieldShowFilterField = ({
  showFilter,
  onShowFilterChange,
}) => (

  <ModalField>

    <ModalLabel label="Show Filter" />
    <ModalHint hint="Adds a filter field at the top of the select list for long relation lists." />

    <Checkbox
      value={showFilter === true}
      size="22"
      label="Show filter in select list"
      onChange={() => onShowFilterChange(!(showFilter === true))}
    />

  </ModalField>

);

// Dev Tools
FieldShowFilterField.displayName = 'FieldShowFilterField';

export default FieldShowFilterField;
